<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wTbiQj/tc-custom/9781480483668.jpg?1704316987281" alt="This image is the cover for the book Journey to the Center of the Earth, Extraordinary Voyages"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Journey to the Center of the Earth, Extraordinary Voyages
      </h1>
      <p class="bookDescription body article font2">
        <b>One hundred fifty years later, Jules Verne’s epic novel of science and adventure is just as thrilling as when it was first published</b> <br/><br/> A dirty slip of parchment falls from the pages of an ancient manuscript. Deciphered by the indefatigable Otto Liedenbrock, professor of geology, and his reluctant nephew, Axel, the parchment’s coded message is a wild assertion made by a medieval alchemist: Inside a volcano in Iceland is a passageway to the center of the earth. Impossible, says Axel—the temperature of the earth’s core is far too high for any human being to go near it. That is one theory, the professor replies. Two days later, they embark on a journey so fantastic it will alter the very meaning of history.  <br/>  <br/> First published in 1864, <i>Journey to the Center of the Earth </i>is a cornerstone of science fiction and one of the greatest stories ever told. This ebook edition contains the classic Ward Lock &amp; Co. translation of 1877, one of the first English-language versions faithful to the original French.  <br/><br/> This ebook has been professionally proofread to ensure accuracy and readability on all devices.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jules Verne
      </h2>
      
      <p class="authorDescription body article">Jules Verne (1828&ndash;1905) was a French author best known for his tales of adventure, including&#160;<I>Twenty Thousand Leagues under the Sea</I>,&#160;<I>Journey to the Center of the Earth</I>, and&#160;<I>Around the World in Eighty Days</I>. A true visionary, Verne foresaw the skyscraper, the submarine, and the airplane, among many other inventions, and is now regarded as one of the fathers of science fiction.&#160;<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?37a1ab64